import { employeeSalaries } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectEmployeeSalarySchema = createSelectSchema(employeeSalaries)

export const insertEmployeeSalarySchema = createInsertSchema(
  employeeSalaries,
).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

export type EmployeeSalary = z.infer<typeof selectEmployeeSalarySchema>
export type CreateEmployeeSalary = z.infer<typeof insertEmployeeSalarySchema>
